<template>
  <div class="nuttrema-calivi">

    <div class="nuttrema-calivi__calendar" ref="calendar">
      <datepicker
         v-model="option.date"
         wrapper-class="calivi-calendar"
        :inline="true"
        :highlighted="highlighted"
        @selected="changeDate">
      </datepicker>
    </div>

    <div class="nuttrema-calivi__list" ref="list" :class="{ 'is-slided': !open.list }">
      <button-resize-toggler
         class="is-bottom-side"
        :title="$t('label.change_date')"
        :collapsed="open.list"
        @click="toggleList">
      </button-resize-toggler>

      <nuttrema-calivi-list
        :date="scheduleDate"
        :ScheduledDateSchedules="ScheduledDateSchedules"
        @change-date="toggleList"
        @view-schedule-detail="onViewScheduleDetail">
      </nuttrema-calivi-list>
    </div>
    <div class="nuttrema-calivi__view" ref="view" :class="{ 'is-open': open.view }">
      <nuttrema-calivi-view
         v-if="open.view"
        :ScheduleDetails="ScheduleDetails"
        @close="toggleView">
      </nuttrema-calivi-view>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { get, find } from 'lodash';
import { TimelineMax, Power4 } from 'gsap';

import ButtonResizeToggler from 'components/ui/button/button-resize-toggler';
import Datepicker from 'vuejs-datepicker';

import NuttremaCaliviList from './nuttrema-calivi-list';
import NuttremaCaliviView from './nuttrema-calivi-view';

export default {
  name: 'nuttrema-calivi',
  props: {
    speed: {
      type: Object,
      required: false,
      default() {
        return {
          list: 0.25,
          view: 0.5,
        };
      },
    },
    ScheduledDateSchedules: {
      required: true,
      default: null,
    },
    ScheduleDetails: {
      required: true,
      default: null,
    },
    ScheduledDates: {
      required: true,
      default: null,
    },
    scheduleDate: {
      type: Date,
      required: false,
      default: null,
    },
    email: {
      required: false,
      default: null,
    },
    scheduleID: {
      required: false,
      default: null,
    },
  },
  components: {
    Datepicker,
    NuttremaCaliviList,
    NuttremaCaliviView,
    ButtonResizeToggler,
  },
  data() {
    return {
      tl: null,
      option: {
        date: null,
      },
      highlighted: {
        customPredictor: (date) => {
          const scheduleDates = get(this.ScheduledDates, 'data', []);
          const haveSchedule = find(scheduleDates, item => item.date === moment(date).format('YYYY-MM-DD'));
          return haveSchedule !== undefined;
        },
      },
      open: {
        list: true,
        calendar: false,
        view: false,
      },
    };
  },
  methods: {
    toggleList(toggle = true) {
      const list = this.$refs.list;
      const calendarHeight = this.$refs.calendar.offsetHeight + 10;

      let to = this.open.list ? { y: '0px' } : { y: `${calendarHeight}px` };

      if (toggle) {
        to = this.open.list ? { y: `${calendarHeight}px` } : { y: '0px' };
        this.open.list = !this.open.list;
      }

      this.tl.to(list, this.speed.list, {
        y: to.y,
        ease: Power4.easeInOut,
      });
    },
    toggleView(toggle = true) {
      const view = this.$refs.view;

      let to = this.open.view ? { y: '0%', opacity: 1 } : { y: '100%', opacity: 0 };

      if (toggle) {
        to = this.open.view ? { y: '100%', opacity: 0 } : { y: '0%', opacity: 1 };
        this.open.view = !this.open.view;
      }

      this.tl.to(view, this.speed.view, {
        y: to.y,
        opacity: to.opacity,
        ease: Power4.easeInOut,
      });
    },
    changeDate(date) {
      // this.$emit('update:scheduleDate', date);
      this.$emit('changeScheduleDate', date);
      this.toggleList();
    },
    onViewScheduleDetail(scheduleID, childScheduleID) {
      // console.log('onViewScheduleDetail', scheduleID);
      this.$emit('changeScheduleID', scheduleID, childScheduleID);
      this.toggleView();
    },
  },
  mounted() {
    this.option.date = this.scheduleDate;
    this.tl = new TimelineMax();

    if (this.scheduleID !== null) {
      this.toggleView();
    } else {
      this.toggleList(false);
      this.toggleView(false);
    }
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/mixins/gradients';
  @import "~styles/theme/person-colors";

  $bg-color-from: #B786F5;
  $bg-color-to: #A784F5;

  // $bg-color-from: #2042A3;
  // $bg-color-to: #101C59;

  .nuttrema-calivi {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-x: visible;
    overflow-y: hidden;
    -ms-overflow-style: none;
    -webkit-font-smoothing: antialiased;

    transition: all 0.25s linear;

    @include gradient-horizontal($bg-color-from, $bg-color-to);

    .nuttrema-calivi__list {
      position: absolute;
      background: #fff;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-top-left-radius: 0;
      border-top-right-radius: 0;

      padding-top: 1.5em;

      &.is-slided {
        border-top-left-radius: 0.5em;
        border-top-right-radius: 0.5em;
      }
    }

    .nuttrema-calivi__view {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      position: absolute;
      background: #fff;
      display: flex;
    }

    .nuttrema-calivi__calendar {
      padding: 0.5em 0;
      text-align: center;
    }

    .vdp-datepicker {
      &.calivi-calendar {
        display: inline-block;
        /deep/ .vdp-datepicker__calendar {
          color: #fff;
          border: none;
          background: transparent;
          header {
            .prev {
              &:after {
                border-right-color: #fff;
              }
            }
            .next {
              &:after {
                border-left-color: #fff;
              }
            }
            .up:not(.disabled):hover, .prev:not(.disabled):hover, .next:not(.disabled):hover {
              background: transparent;
            }
          }

          .cell.day {
            position: relative;
            height: 42px;
            line-height: 42px;
            border-radius: 50%;
            &.selected {
              border: none;
              background-color: darken($bg-color-to, 10%);
            }
            &.today {
              color: #03A9F4;
              font-weight: 600;
            }
            &:hover {
              border-color: transparent;
            }
            &:focus {
              outline: none;
            }
            &.highlighted {
              &:after {
                position: absolute;
                content: '';
                width: 4px;
                height: 4px;
                border-radius: 50%;
                background-color: #fff;
                left: calc(50% - 2px);
                bottom: 4px;
              }
            }
            &.highlighted:not(.selected) {
              background-color: transparent;
            }
          }
          .cell.month, .cell.year {
            border-radius: 0.5em;
            &.selected {
              border: none;
              background-color: darken($bg-color-to, 10%);
            }
          }
        }
      }
    }

    &.is-male {
      @include gradient-horizontal($male-calendar-gradient-from, $male-calendar-gradient-to);
      .vdp-datepicker.calivi-calendar {
        /deep/ .vdp-datepicker__calendar {
          .cell.day{
            &.selected { background-color: darken($male-calendar-gradient-to, 10%); }
            &.today { color: #ffc107; }
          }
        }
      }
    }

    &.is-female {
      @include gradient-horizontal($female-calendar-gradient-from, $female-calendar-gradient-to);
      .vdp-datepicker.calivi-calendar {
        /deep/ .vdp-datepicker__calendar {
          .cell.day{
            &.selected { background-color: darken($female-calendar-gradient-to, 10%); }
            &.today { color: #ffc107; }
          }
        }
      }
    }

    .is-for-desktop &,
    .for-big-desktop & {
      // bottom: 1em;
      border-bottom-left-radius: 0.5em;
      border-bottom-right-radius: 0.5em;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/schedules/nuttrema-calivi.vue